import React from 'react';
import { Background } from '../../../features/api/apiSlice';
import styles from './BackgroundRenderer.module.css';
import cn from "classnames";

interface BackgroundRendererProps {
  background: Background;
  videoClassName?: string;
  imageClassName?: string;
}

export const BackgroundRenderer: React.FC<BackgroundRendererProps> = ({
  background,
  videoClassName,
  imageClassName
}) => {
  if (background.type === "none") {
    return (
      <div
        className={cn(styles['background-renderer__none'], imageClassName)}
      />
    );
  }

  if (background.type === "video") {
    return (
      <div className={styles['background-renderer']}>
        <video
          playsInline
          autoPlay
          muted
          loop
          src={background.url}
          className={cn(styles['background-renderer__video'], videoClassName)}
        />
      </div>
    );
  }

  return (
    <div className={styles['background-renderer']}>
      <img
        src={background.url}
        alt={background.type}
        className={cn(styles['background-renderer__image'], imageClassName)}
      />
    </div>
  );
};